import { render, staticRenderFns } from "./SimpleBasic.vue?vue&type=template&id=1046d86f&"
import script from "./SimpleBasic.vue?vue&type=script&lang=js&"
export * from "./SimpleBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports